import React from "react"
import get from 'lodash/get'
import set from 'lodash/set'
import reject from 'lodash/reject'
import startsWith from 'lodash/startsWith'
import clone from 'lodash/clone'
import moment from '../../../lib/moment.js'
import Searchbar from '../searchbar/searchbar-other-cost'
import OtherCostTable from '../table/table-other-cost'
import { addButton } from '../helper/button'
import { ConfirmSaveForm, AddOtherCostForm } from '../form'

export default class OtherCostTab extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'projectByID')
    && JSON.stringify(get(nextProps, 'projectByID')) !== JSON.stringify(prevState.projectByID)
    ) {
      const projectByID = get(nextProps, 'projectByID')
      set(tempState, 'projectByID', projectByID)
      set(tempState, 'other_costs', projectByID.other_costs)
      set(tempState, '$other_cost_per_month', projectByID.$other_cost_per_month)
    }
    if (get(nextProps, 'editOtherCost') !== get(prevState, 'editOtherCost')) {
      set(tempState, 'editOtherCost', get(nextProps, 'editOtherCost'))
    }
    return tempState
  }

  state={
    showAddOtherCost: false,
    editOtherCost: false,
    search_other: '',
    other_costs: [],
    $other_cost_per_month: [],

    other_cost_name: '',
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
    && JSON.stringify(this.state) === JSON.stringify(nextState)) return false
    return true
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  addOtherCost = () => {
    const oldOtherCosts = this.state.other_costs
    let temp_other_cost = []
    const other_cost = {}
    const cost_months = []
    const end_date = this.state.projectByID.end_date
    let start_date = this.state.projectByID.start_date
    if (start_date !== '' && end_date !== '') {
      while (moment(start_date).isSameOrBefore(moment(end_date), 'month')) {
        cost_months.push({ month: `${moment(start_date).format('YYYY')}-${moment(start_date).format('MM')}`, cost: 0 })
        start_date = moment(start_date).add(1, 'month')
      }
    }
    other_cost.cost_name = this.state.other_cost_name
    other_cost.cost_month = cost_months
    temp_other_cost = [...oldOtherCosts, other_cost]
    this.setState({
      showAddOtherCost: !this.state.showAddOtherCost,
      other_costs: temp_other_cost,
    })
  }

  editOtherCost = () => {
    this.setState({ showConfirmSave: !this.state.showConfirmSave })
  }

  resetProject = () => this.setState({ projectByID: null })

  confirmEditOtherCost = async () => {
    const editProjectInformation = get(this.props, 'editProjectInformation')
    let edit_other_cost = []
    edit_other_cost = this.state.other_costs.map(oc => {
      const filteredMonth = reject(oc.cost_month, om => {
        const { month } = om
        return startsWith(month, '-')
      })
      return {
        cost_name: oc.cost_name,
        cost_month: filteredMonth,
      }
    })
    const payload = clone(this.state.projectByID)
    delete payload.project_type
    delete payload.created
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload._id
    delete payload.updated_by
    payload.other_costs = edit_other_cost
    await editProjectInformation(payload)
    this.setState({ showConfirmSave: !this.state.showConfirmSave })
    this.props.setIsEdit(false)
  }

  deleteOtherCost = (id) => {
    const other_costs = clone(this.state.other_costs)
    other_costs.splice(id, 1)
    this.setState({ other_costs })
  }

  handleChangeOtherCost = (e, other_cost_key, month_key) => {
    const newOtherCosts = clone(this.state.other_costs)
    const other_cost = clone(this.state.other_costs[other_cost_key])
    const field = e.target.name
    if (other_cost.cost_month.length === 0) {
      const cost_months = []
      const end_date = this.state.projectByID.end_date
      let start_date = this.state.projectByID.start_date
      if (start_date !== '' && end_date !== '') {
        while (moment(start_date).isSameOrBefore(moment(end_date), 'month')) {
          cost_months.push({ month: `${moment(start_date).format('YYYY')}-${moment(start_date).format('MM')}`, cost: 0 })
          start_date = moment(start_date).add(1, 'month')
        }
      }
      other_cost[field] = cost_months
    }
    const res = other_cost[field][month_key]
    res.cost = parseFloat(e.target.value.replace(/,/g, '')) // parseFloat(e.target.value)
    other_cost[field][month_key] = res
    newOtherCosts[other_cost_key] = other_cost
    this.setState({ other_costs: newOtherCosts })
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  /* eslint no-underscore-dangle: 0 */
  render() {
    const { hideHeader } = this.props
    const getProjectInformationByID = get(this.props, 'getProjectInformationByID')
    const clickEditOtherCost = get(this.props, 'clickEditOtherCost')
    return (
      <div style={ { background: '#FFFFFF' } }>
        <ConfirmSaveForm
          open={ this.state.showConfirmSave }
          toggle={ () => this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          confirmSave={ this.confirmEditOtherCost }
        />
        <AddOtherCostForm
          open={ this.state.showAddOtherCost }
          button={ addButton('addOtherCost', () => this.addOtherCost(), () => this.setState({ showAddOtherCost: !this.state.showAddOtherCost })) }
          handleInput={ this.handleInput }
          toggle={ () => this.setState({ showAddOtherCost: !this.state.showAddOtherCost }) }
        />
        <Searchbar
          editOtherCost={ this.state.editOtherCost }
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          clickEdit={ () => clickEditOtherCost() }
          clickAddOtherCost={ () =>
            this.setState({
              showAddOtherCost: !this.state.showAddOtherCost,
              other_cost_name: '',
            }) }
          confirmEditOtherCost={ () =>
            this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          cancelEdit={ () => {
            clickEditOtherCost()
            this.setState({ projectByID: null })
            getProjectInformationByID()
          } }
        />
        <OtherCostTable
          hideHeader={ hideHeader }
          editOtherCost={ this.state.editOtherCost }
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          other_costs={ this.state.other_costs }
          $other_cost_per_month={ this.state.$other_cost_per_month }
          search_other={ this.state.search_other }
          deleteOtherCost={ this.deleteOtherCost }
          handleChangeOtherCost={ this.handleChangeOtherCost }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-other-cost.js